import { Component } from '@angular/core';
import { Router, RouterOutlet } from '@angular/router';
import { EnvService, IRPC, L, RpcError } from '@ic2/ic2-lib';
import { gestionPialVersion } from 'src/environments/version';
import { CookieBannerComponent } from './components/cookie-banner/cookie-banner.component';
import { FooterComponent } from './components/footer/footer.component';
import { AuthGuard } from './tools/auth-guard.service';
import { AuthService } from './tools/auth.service';
import { Config } from './tools/Config';
import { Ic2ToastrService } from './tools/ic2-toastr.service';

/**
 * Appels dont le NOT_LOGGED ne doit PAS renvoyer au login : les vérifications de session (leur erreur doit
 * arriver à AuthService.isLoggedIn) et les appels de déconnexion (session déjà morte, c'est attendu).
 */
const NOT_LOGGED_EXCLUDED = new Set([
  'CoreService.getBundle',
  'CoreService.disconnect',
  'RefreshSessionService.refreshSession',
  'RefreshSessionService.revokeRefreshToken',
]);

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet, FooterComponent, CookieBannerComponent],
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent {
  constructor(
    public irpc: IRPC,
    router: Router,
    private authService: AuthService,
    authGuard: AuthGuard,
    ic2ToastrService: Ic2ToastrService,
    env: EnvService<Config>
  ) {
    irpc.url = env.configuration.rpcHost + '/rpc';
    if (env.configuration.name === 'DEV') {
      irpc.url = 'http://' + window.location.hostname + ':8080/rpc';
    }
    irpc.log = env.configuration.logRpcRequests;
    irpc.version = gestionPialVersion.fullHash;

    irpc.defaultOnError = (err) => {
      L.e(err);
      ic2ToastrService.show('Une erreur est survenue', { classname: 'bg-danger text-white' });
    };

    irpc.interceptErrorHandlers.push((req, err) => {
      // Un appel authentifié répond NOT_LOGGED : la session est perdue côté serveur (expirée, révoquée,
      // serveur redémarré). Retour au login, qui tente d'abord la reconnexion silencieuse. Surtout pas de
      // logout() ici : il révoquerait le jeton de reconnexion avant qu'il ait servi.
      if (err.code === RpcError.NOT_LOGGED && !NOT_LOGGED_EXCLUDED.has(req.req.method) && authService.userBundle !== null) {
        console.log('INTERCEPTED NOT LOGGED ERROR on ' + req.req.method);
        authService.sessionLost();
        return true;
      }
      if (err.isVersionError()) {
        if (router.url !== '/update') localStorage.setItem('redirectUrl', router.url);
        router.navigate(['/update']);
        return true;
      }
      if (!err.isBusinessError() && authService.userBundle !== null) {
        ic2ToastrService.show('Une erreur est survenue', { classname: 'bg-danger text-white' });
      }
      return false;
    });
    authGuard.redirectLoginRoute = '/login';

    authService.loginEvent.subscribe((login) => {
      console.log('setting up login action');
      login.onLoginAction = () => Promise.all([]);
    });
  }
}
